export default __webpack_public_path__ + "static/media/electric1.4809aa18.jpg";